// DEV: firebase deploy --only hosting:multinom-dev-comite (compila con --configuration development)
export const environment = {
  production: false,
  apiUrl: 'https://dev-api.multinom.com.mx',
  loginUrl: 'https://dev.multinom.com.mx',
  cveModulo: 'CMT',
};
